import { Directive, HostBinding, Input } from "@angular/core";
import { NgControl } from "@angular/forms";

export interface IsFormControlInvalidArg {
    touched: boolean;
    invalid: boolean;
}

function isFormControlInvalid(element: IsFormControlInvalidArg): boolean {
    return element?.touched && element?.invalid;
}

/**
 * The form error class directive.
 * Its goal is to add a 'is-invalid' class to inputs and selects
 * when the associated form control is invalid and touched.
 */
@Directive({
    // tslint:disable-next-line: directive-selector
    selector: "[formControlName],[ngModel],[formControl]",
})
export class FormErrorClassDirective {
    @HostBinding("class.is-invalid")
    get classIsInvalid(): boolean {
        return isFormControlInvalid(this.ngControl);
    }

    constructor(private readonly ngControl: NgControl) {}
}

/**
 * Applies the is-invalid class to the HTML element depending on another element.
 * Particularly useful when you want an underlying form-control to reflect the same is-invalid class.
 */
@Directive({
    // tslint:disable-next-line: directive-selector
    selector: "[formErrorClassFrom]",
})
export class FormErrorClassFromDirective {
    @Input()
    formErrorClassFrom: { ngControl: IsFormControlInvalidArg } = null;

    /**
     * Applies the is-invalid class base don the state of the provided element state.
     */
    @HostBinding("class.is-invalid")
    get classIsInvalid(): boolean {
        return isFormControlInvalid(this.formErrorClassFrom?.ngControl);
    }
}
